import "./Product.css";
import { useState } from "react";

export default function Product(props) {
    const [showDescription, setShowDescription] = useState(false);

    return (
        <div className="product">
            <div className="productImageContainer"
                onMouseEnter={() => setShowDescription(true)}
                onMouseLeave={() => setShowDescription(false)}
            >
                <img className="productImg" src={props.img} />
                <div className={`productDescriptionContainer ${showDescription ? "show" : ""}`}>
                    <p className="productImgDescription">{props.description}</p>
                </div>
            </div>

            <p className="productHeading">{props.heading}</p>
        </div>
    );
}